import { render, staticRenderFns } from "./EditCurrent.vue?vue&type=template&id=7767063a&lang=true"
import script from "@/views/modules/FormatSettings/js/EditCurrent.js?vue&type=script&lang=js&external"
export * from "@/views/modules/FormatSettings/js/EditCurrent.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports